import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton, InputAdornment, OutlinedInputProps } from '@mui/material';
import { I18nStore } from '@tools/i18n/store';
import { injectTSDI } from '@tools/tsdi';
import { FieldState } from 'formstate';
import { observer } from 'mobx-react';
import * as React from 'react';

import DefaultTextField from '../text-field';

type PasswordFieldProps = {
    field: FieldState<string>;
    helperText: React.ReactNode;
    dataRole?: string;
} & OutlinedInputProps;

const DefaultPasswordField = (props: PasswordFieldProps) => {
    const { translate } = injectTSDI(I18nStore);
    const { label, field, dataRole = 'password', inputProps, ...rest } = props;

    const [passwordVisibility, setPasswordVisibility] = React.useState(false);

    return (
        <DefaultTextField
            label={label || translate('commons.password')}
            autoComplete="new-password"
            field={field}
            type={passwordVisibility ? 'text' : 'password'}
            inputProps={{
                'data-role': dataRole,
                ...inputProps
            }}
            endAdornment={
                <InputAdornment position="end">
                    <IconButton
                        data-testid="adornment"
                        aria-label={translate('signup.passwordvisibility')}
                        onClick={() =>
                            setPasswordVisibility(!passwordVisibility)
                        }
                        onMouseDown={(
                            event: React.MouseEvent<HTMLButtonElement>
                        ) => event.preventDefault()}
                    >
                        {passwordVisibility ? (
                            <Visibility data-testid="icon-on" />
                        ) : (
                            <VisibilityOff data-testid="icon-off" />
                        )}
                    </IconButton>
                </InputAdornment>
            }
            {...rest}
        />
    );
};

export default observer(DefaultPasswordField);
